import type { DiagramEdge, DiagramNode } from './types';

export interface SpatialNodeIndex { cellSize:number; cells:Map<string,DiagramNode[]>; visibleCount:number; }
function key(x:number,y:number){return `${x}:${y}`;}
export function buildSpatialNodeIndex(nodes:DiagramNode[],cellSize=640):SpatialNodeIndex { const cells=new Map<string,DiagramNode[]>(); let visibleCount=0; for(const node of nodes){if(node.hidden)continue; visibleCount++; const minX=Math.floor(node.x/cellSize),maxX=Math.floor((node.x+node.width)/cellSize),minY=Math.floor(node.y/cellSize),maxY=Math.floor((node.y+node.height)/cellSize); for(let x=minX;x<=maxX;x++)for(let y=minY;y<=maxY;y++){const k=key(x,y),list=cells.get(k)??[];list.push(node);cells.set(k,list);}} return {cellSize,cells,visibleCount}; }
export function querySpatialNodeIndex(index:SpatialNodeIndex,left:number,top:number,right:number,bottom:number):DiagramNode[]{ const minX=Math.floor(left/index.cellSize),maxX=Math.floor(right/index.cellSize),minY=Math.floor(top/index.cellSize),maxY=Math.floor(bottom/index.cellSize); const result=new Map<string,DiagramNode>(); for(let x=minX;x<=maxX;x++)for(let y=minY;y<=maxY;y++)for(const node of index.cells.get(key(x,y))??[])result.set(node.id,node); return [...result.values()]; }


export interface SpatialEdgeIndex { cellSize:number; cells:Map<string,DiagramEdge[]>; visibleCount:number; edgeById:Map<string,DiagramEdge>; }

export function buildSpatialEdgeIndex(nodes:DiagramNode[], edges:DiagramEdge[], cellSize=640):SpatialEdgeIndex {
  const cells=new Map<string,DiagramEdge[]>();
  const edgeById=new Map<string,DiagramEdge>();
  const nodeById=new Map(nodes.filter((node)=>!node.hidden).map((node)=>[node.id,node]));
  let visibleCount=0;
  for(const edge of edges){
    const source=nodeById.get(edge.sourceId),target=nodeById.get(edge.targetId);
    if(!source||!target)continue;
    visibleCount++; edgeById.set(edge.id,edge);
    const points=[
      {x:source.x,y:source.y},{x:source.x+source.width,y:source.y+source.height},
      {x:target.x,y:target.y},{x:target.x+target.width,y:target.y+target.height},
      ...(edge.waypoints??[]),
    ];
    const xs=points.map((point)=>point.x),ys=points.map((point)=>point.y);
    const minX=Math.floor(Math.min(...xs)/cellSize),maxX=Math.floor(Math.max(...xs)/cellSize),minY=Math.floor(Math.min(...ys)/cellSize),maxY=Math.floor(Math.max(...ys)/cellSize);
    for(let x=minX;x<=maxX;x++)for(let y=minY;y<=maxY;y++){const k=key(x,y),list=cells.get(k)??[];list.push(edge);cells.set(k,list);}
  }
  return {cellSize,cells,visibleCount,edgeById};
}

export function querySpatialEdgeIndex(index:SpatialEdgeIndex,left:number,top:number,right:number,bottom:number):DiagramEdge[]{
  const minX=Math.floor(left/index.cellSize),maxX=Math.floor(right/index.cellSize),minY=Math.floor(top/index.cellSize),maxY=Math.floor(bottom/index.cellSize);
  const result=new Map<string,DiagramEdge>();
  for(let x=minX;x<=maxX;x++)for(let y=minY;y<=maxY;y++)for(const edge of index.cells.get(key(x,y))??[])result.set(edge.id,edge);
  return [...result.values()];
}
